import { NavbarCtas } from './navbar-ctas';
import type { NavbarMobileBottomProps } from './type';

export function NavbarMobileBottom({
  bottom,
  ctaHref,
  onClickCta,
  phone,
}: NavbarMobileBottomProps) {
  return (
    <div
      className="rounded-t-2xl bg-white/50 backdrop-blur-[6.5px] fixed bottom-0 left-0 right-0 z-100 grid grid-cols-2 gap-2 py-4 px-2"
      style={{ bottom, transition: 'bottom 0.3s ease-out' }}
    >
      <NavbarCtas onClickCta={onClickCta} ctaHref={ctaHref} initialState={false} phone={phone} />
    </div>
  );
}
